import axios from 'axios';
import rddApiConfig from './rddApiConfig';
// "ReferenceError: regeneratorRuntime is not defined" when used async/await: https://github.com/babel/babel/issues/5085
// in the form "async => await () => ..."
// This page suggests it can be done without including the polyfill: https://www.valentinog.com/blog/how-async-await-in-react/
import '@babel/polyfill';

const triggerProblemStateApi = {};

// https://medium.com/codingthesmartway-com-blog/getting-started-with-axios-166cb0035237
// https://kapeli.com/cheat_sheets/Axios.docset/Contents/Resources/Documents/index
triggerProblemStateApi.getById = async (triggerProblemStateId) => {
  const response = await axios.get('trigger-problem-state/graph-configuration?triggerProblemStateId=' + triggerProblemStateId, rddApiConfig);
  return response.data;
}

export default triggerProblemStateApi;
